@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}

@if (showSpinner()) {
  <div class="spinner">
    <div class="busyContents">
      <mat-progress-spinner diameter="60" mode="indeterminate"></mat-progress-spinner>
      <span class="busyLabel">Please Wait...</span>
    </div>
  </div>
}

@if (showLineAssignmentsTab()) {
  <mat-tab-group class="special-quote-tabs">
    <mat-tab label="Manage Special Quotes">
      <ng-container [ngTemplateOutlet]="manageSpecialQuotes"></ng-container>
    </mat-tab>
    <mat-tab label="Line Assignments">
      <div class="line-assignments-tab">
        <div class="dialog-header">
          <span class="spacer"></span>
          <h2>Line Assignments</h2>
          <span class="spacer"></span>
          <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div class="line-assignments">
          <div class="line-assignments-pane">
            <div class="pane-title">Lines</div>
            <table mat-table [dataSource]="entityLines()" class="mat-elevation-z2 bordered-table line-table">
              <ng-container matColumnDef="lineId">
                <th mat-header-cell *matHeaderCellDef>Line</th>
                <td mat-cell *matCellDef="let element">{{ element.lineId }}</td>
              </ng-container>

              <ng-container matColumnDef="product">
                <th mat-header-cell *matHeaderCellDef>Product</th>
                <td mat-cell *matCellDef="let element">{{ element.configured ? element.description : element.product }}</td>
              </ng-container>

              <ng-container matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef>Quantity</th>
                <td mat-cell *matCellDef="let element">{{ element.quantity }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="lineColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: lineColumns;" class="line-row"
                  [class.selected-line]="row.lineId === selectedLineId()" (click)="selectLine(row.lineId)"></tr>
            </table>
            @if (entityLines().length === 0) {
              <div class="pane-message">There are no lines on this quote.</div>
            }
          </div>

          <div class="line-assignments-pane">
            <div class="pane-title">
              @if (selectedLineId(); as lineId) {
                Special Quotes for Line {{ lineId }}
              } @else {
                Special Quotes
              }
            </div>
            @if (!selectedLineId() && externalSpecials().length > 0) {
              <div class="pane-message">Select a line to assign special quotes to it.</div>
            }
            @for (externalSpecial of externalSpecials(); track externalSpecial.externalId) {
              <div>
                <mat-checkbox [checked]="selectedLineAssignments().has(externalSpecial.externalId)" [disabled]="!selectedLineId()"
                              (change)="toggleLineAssignment(externalSpecial.externalId, $event)">
                  {{ externalSpecial.externalId }}@if (externalSpecial.description) { - {{ externalSpecial.description }}}
                </mat-checkbox>
              </div>
            } @empty {
              <div class="pane-message">There are no special quotes on this quote.</div>
            }
          </div>
        </div>

        <div class="side-margin bottom-margin">
          <button class="input-button" matButton="elevated" [disabled]="!hasUnsavedLineAssignments() || showSpinner()" (click)="saveLineAssignments()">Save</button>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
} @else {
  <ng-container [ngTemplateOutlet]="manageSpecialQuotes"></ng-container>
}

<ng-template #manageSpecialQuotes>
  @if (showRequestList()) {
    <div class="dialog-header sticky-header">
      <span class="spacer"></span>
      <h2>Manage Special Quote Requests</h2>
      <span class="spacer"></span>
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="table-container">
      <table mat-table [dataSource]="externalSpecialRequests()" class="quoteTable">
        <ng-container matColumnDef="externalId">
          <th mat-header-cell *matHeaderCellDef>Quote Number</th>
          <td mat-cell *matCellDef="let element">
            @if (hasSpecialQuoteAccess()) {
              <button class="quoteNumberLink" (click)="showRequest(element.externalSpecialRequest.externalId)">{{ element.externalSpecialRequest.externalId }}</button>
            } @else {
              {{ element.externalSpecialRequest.externalId }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>Description</th>
          <td mat-cell *matCellDef="let element"> {{ element.description }}</td>
        </ng-container>

        <ng-container matColumnDef="processStatus">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element"> {{ processStatusTranslation(element.externalSpecialRequest.processStatus) }}</td>
        </ng-container>

        <ng-container matColumnDef="taskOpen">
          <th mat-header-cell *matHeaderCellDef>Task</th>
          <td mat-cell *matCellDef="let element"> {{ taskTranslation(element.taskOpen) }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="requestColumns()"></tr>
        <tr mat-row *matRowDef="let row; columns: requestColumns();"></tr>
      </table>
    </div>
    <div class="side-margin">
      @if (hasSpecialQuoteAccess()) {
        <button class="input-button" matButton="elevated" (click)="createNewRequest()">Create New Request</button>
      }
    </div>
  }

  @if (showQuoteRequestForm() && hasSpecialQuoteAccess()) {
    <div class="dialog-header sticky-header">
      <span class="spacer"></span>
      <h2>HVAC Special Engineering Quote Form</h2>
      <span class="spacer"></span>
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <ng-container [ngTemplateOutlet]="addRequestTable"></ng-container>
  }

  @if (showSpecialQuoteTable()) {
    <ng-container [ngTemplateOutlet]="specialQuoteTable"></ng-container>
  }

  @if (showSaveAndFinalizeButtons() || showApplicationEngineerCancelButton()) {
    <div class="side-margin">
      @if (showSaveAndFinalizeButtons()) {
        <button class="input-button" matButton="elevated" [disabled]="!showSaveButton()" (click)="saveSpecialQuote(false)">Save</button>
      }
      @if (showFinalizeButtonVisible()) {
        <button class="input-button" matButton="elevated" [disabled]="!showFinalizeButton()" (click)="saveSpecialQuote(true)">Finalize</button>
      }
      @if (showApplicationEngineerCancelButton()) {
        <button class="input-button" matButton="elevated" (click)="applicationEngineerCancel()">Cancel</button>
      }
    </div>
  }
</ng-template>

<ng-template #specialQuoteTable>
  <div class="dialog-header top-margin border-top">
    <span class="spacer"></span>
    <h2>Manage Special Quotes</h2>
    <span class="spacer"></span>
  </div>
  @if (showAddSpecialQuoteSection()) {
    <div class="side-margin">
      <label class="quoteNumber fieldLabel" for="quoteNumber">Quote Number:</label>
      <input numbersOnly id="quoteNumber" class="standardTextBox" [(ngModel)]="quoteNumber"/>
      <button class="input-button" matButton="elevated" (click)="addQuoteNumber()">Add Special Quote</button>
    </div>
  }
  <div class="side-margin bottom-margin">
    <table mat-table [dataSource]="selectedExternalSpecials()" class="mat-elevation-z2 bordered-table">
      <ng-container matColumnDef="quoteNumber">
        <th mat-header-cell *matHeaderCellDef>Quote</th>
        <td mat-cell *matCellDef="let element"><button class="quoteNumberLink" (click)="showRequestDetail(element)">{{ element.externalId }}</button></td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Description</th>
        <td mat-cell *matCellDef="let element">
          @if (element.description && element.description.length < 25) {
            <label [matTooltip]="element.description">
            {{ element.description }}
            </label>
          } @else if(element.description) {
            <label [matTooltip]="element.description">
              {{ element.description | slice:0:25 }}...
            </label>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="pricePerUnit">
        <th mat-header-cell *matHeaderCellDef>Price Per Unit</th>
        <td mat-cell *matCellDef="let element">
          @if (isITUser || isAppEngUser){
            <input class="cellInput" [(ngModel)]="element.pricePerUnit"/>
          } @else {
            {{ element.pricePerUnit }}
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="setupFee">
        <th mat-header-cell *matHeaderCellDef>Setup Fee</th>
        <td mat-cell *matCellDef="let element">
          @if (isITUser || isAppEngUser){
            <input class="cellInput" [(ngModel)]="element.setupFee"/>
          } @else {
            {{ element.setupFee }}
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="qty">
        <th mat-header-cell *matHeaderCellDef>Qty</th>
        <td mat-cell *matCellDef="let element">
          @if (isITUser || isAppEngUser){
            <input class="cellInput" [(ngModel)]="element.specialQty"/>
          } @else {
            {{ element.specialQty }}
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element"> {{ quoteStatusTranslation(element.quoteStatus) }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Actions</th>
        <td mat-cell *matCellDef="let element">
          <button class="warn-button" mat-icon-button
                  (click)="deleteRow(element.externalId)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>
      @if (isAppEngUser || isITUser) {
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      } @else {
        <tr mat-header-row *matHeaderRowDef="readOnlyDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: readOnlyDisplayedColumns;"></tr>
      }
    </table>
  </div>
</ng-template>

<ng-template #addRequestTable>
  <table class="requestTable">
    <tr>
      <td>
        <label class="fieldLabel" for="projectName">Project Name:</label>
        <br>
        <input id="projectName" class="standardTextBox" [value]="projectName() ?? ''" readonly/>
      </td>
      <td>
        <label class="fieldLabel" for="specialUnitsNumber">Total Number of Special Units:</label>
        <br>
        <input numbersOnly id="specialUnitsNumber" class="standardTextBox" [(ngModel)]="specialQuoteRequest().numSpecialUnits" [readonly]="isReadOnly()"/>
      </td>
    </tr>
    <tr>
      <td>
        <label class="fieldLabel" for="unitsNumber">Total Number Of Unit on Project:</label>
        <br>
        <input id="unitsNumber" class="standardTextBox" [value]="numUnitsInProject() ?? ''" readonly/>
      </td>
      <td>
        <label class="fieldLabel" for="projectValue">Approximate Project Value:</label>
        <br>
        <input id="projectValue" class="standardTextBox" [value]="projectValue() ?? ''" readonly/>
      </td>
    </tr>
    <tr>
      <td>
        <label class="fieldLabel" for="competitor">Competitor:</label><br>
        <mat-select id="competitor" [(ngModel)]="specialQuoteRequest().competitorId" class="formSelect" [disabled]="isReadOnly()">
          @for (competitor of competitors(); track competitor) {
            <mat-option [value]="competitor.competitorId">
              {{ competitor.competitor }}
            </mat-option>
          }
        </mat-select>
      </td>
      <td>
        <label class="fieldLabel" for="unitseries">Unit Series:</label><br>
        <mat-select id="unitseries" [(ngModel)]="specialQuoteRequest().product" class="formSelect" multiple [disabled]="isReadOnly()">
          <mat-select-trigger>
            {{ specialQuoteRequest().product[0] || '' }}
            @if ((specialQuoteRequest().product.length || 0) > 1) {
              <span class="example-additional-selection">
          (+{{ (specialQuoteRequest().product.length || 0) - 1 }} {{ specialQuoteRequest().product.length === 2 ? 'other' : 'others' }})
        </span>
            }
          </mat-select-trigger>
          @for (specialProduct of specialProducts(); track specialProduct) {
            <mat-option [value]="specialProduct">
              {{ specialProduct }}
            </mat-option>
          }
        </mat-select>
      </td>
    </tr>
    <tr>
      <td>
        <label class="fieldLabel" for="fileSelection">Upload Document</label><br>
        <input class="fileInput" type="file" #fileSelection id="fileSelection" (change)="fileSelected(fileSelection.files!)" [disabled]="isReadOnly()"/>
        @if (specialQuoteRequest().fileName) {
          <br>
          <button class="primary-button" matButton="text" (click)="downloadAttachment()">{{ specialQuoteRequest().fileName }}</button>
        }
      </td>
      <td>
        <label class="fieldLabel" for="safetyAgency">Safety Agency Approval Required:</label>
        <br>
        <label class="radioLabel" for="safetyYes"><input type="radio" name="safetyYes" id="safetyYes" value="Y" [(ngModel)]="specialQuoteRequest().safetyAgencyApproval" [disabled]="isReadOnly()"/>Yes</label>
        <label class="radioLabel" for="safetyNo"><input type="radio" name="safetyNo" id="safetyNo" value="N" [(ngModel)]="specialQuoteRequest().safetyAgencyApproval" [disabled]="isReadOnly()"/>No</label>
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <label class="fieldLabel" for="specialNotes">Describe the special feature(s) and list the complete 15 digit units or accessories and quantities for this request</label>
        <br>
        <textarea id="specialNotes" class="standardTextArea" [(ngModel)]="specialQuoteRequest().description" [readonly]="isReadOnly()"></textarea>
      </td>
    </tr>
  </table>
  <div class="side-margin">
    @if (!isRequestClosed() && (!isApproved() || isNewRequest() || isExistingRequestEditable())) {
      <button class="input-button" matButton="elevated" [disabled]="!showSubmitRequestButton()" (click)="submitOrUpdateRequest()">{{ submitRequestLabel() }}</button>
    }
    @if (isRepUser() && isUserCancelable() && !isApproved() && !isRequestClosed()) {
      <button class="input-button" matButton="elevated" (click)="userCancel()">Cancel</button>
    }
    @if (showPreProcessingButtons()) {
      <button class="input-button" matButton="elevated" (click)="preProcessingAction('A')">Approve</button>
      <button class="input-button" matButton="elevated" (click)="preProcessingAction('D')">Deny</button>
      <button class="input-button" matButton="elevated" (click)="preProcessingAction('E')">Use Existing</button>
    }
    <button class="input-button" matButton="elevated" (click)="backToRequests()">Back to Requests</button>
  </div>
</ng-template>
